import { inject, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import StudioUserStore from "../stores/StudioUserStore";
import styled from "styled-components";

import PoluvLogo from "../../assets/img/PoluvLogo.png";
import { useNavigate } from "react-router-dom";

export interface IPolaPolarStudioHomePageState {
  email: string;
  password: string;
  isLogIn: boolean;
  checkingAuth: boolean;
}

export interface IPolaPolarStudioHomePageProps {
  studioUserStore?: StudioUserStore;
}

const PolaPolarStudioHomePage: React.FC<IPolaPolarStudioHomePageProps> = inject("studioUserStore")(observer(({ studioUserStore }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (studioUserStore.isLoggedIn) {
      const role = studioUserStore.me?.role;
      const isAllowed = ["admin", "manager"].includes(role);
      navigate(isAllowed ? "/block" : "/salesStatistics");
    }
  }, [studioUserStore.isLoggedIn, studioUserStore.me?.role, navigate]);

  if (studioUserStore.isLoggedIn) return null;

  return (
     <PageWrapper>
        <LoginCard> 
        {/* 로고 */}
          <LogoWrapper>
            <LogoImage src={PoluvLogo} alt="Logo" />
          </LogoWrapper>

        {/* 로그인 폼 */}
          <Form>
            <FormGroup>
              <Label>이메일</Label>
              <Input
                type="text"
                placeholder="이메일 주소를 입력하세요"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormGroup>

            <FormGroup>
              <Label>비밀번호</Label>
              <Input
                type="password"
                placeholder="비밀번호를 입력하세요"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormGroup>

            <InfoText>사용 시 로그인을 해주세요</InfoText>

            <LoginButton
              onClick={async () => {
                if (!email) {
                  alert("이메일을 입력해주세요!");
                  return;
                }

                if (!password) {
                  alert("패스워드를 입력해주세요!");
                  return;
                }

                try {
                  await studioUserStore.logInAsync(email, password);
                  const role = studioUserStore.me?.role;
                  const isAllowed = ["admin", "manager"].includes(role);
                  navigate(isAllowed ? "/block" : "/salesStatistics");
                } catch (e) {
                  alert(e);
                }
              }}
              >
              로그인
            </LoginButton>
          </Form>
        </LoginCard>
     </PageWrapper>
  )
}))

export default PolaPolarStudioHomePage;


// 스타일
const PageWrapper = styled.div`
  background-color: #d3b8cb;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
`;

const LogoImage = styled.img`
  width: 294px;
  height: 37px;
`;

const LoginCard = styled.div`
  background-color: #fff;
  width: 440px;
  height: 431px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  box-sizing: border-box;
`;

const LoginButton = styled.button`
  width: 100%;
  height: 48px;
  padding: 20px 16px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #645AD2;
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
`;

const Form = styled.div`
  width: 360px;
  height: 282px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormGroup = styled.div`
  margin: 4px;
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 91px;
  gap: 4px;
`;

const Label = styled.label`
  display: inline-block;
  width: 100px;
  font-size: 14px;
  font-weight: 500;
  color: #848890;
`;

const Input = styled.input`
  height: 48px;
  border-radius: 4px;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #C9CCD2;
  font-size: 15px;
  font-weight: 300;
  color: #B7BBC3;
`;

const InfoText = styled.div`
  display: flex;
  width: 360px;
  height: 24px;
  justify-content: center;
  align-items: center;
  font-size: 14px; 
  color: black;
`;